import { previewContentRoutes } from '@frontend/routes/preview/previewContentRoutes'
import { previewLessonRoutes } from '@frontend/routes/preview/previewLessonRoutes'
import { previewTestRoutes } from '@frontend/routes/preview/previewTestRoutes'

export const previewRoutes = [
  ...previewContentRoutes,
  ...previewLessonRoutes,
  ...previewTestRoutes,
]
